import { useCallback } from 'react'
import {
    useEditorActionBarActions,
    useShallowEditorActionBar,
} from '../store/EditorActionBarStore'
import { useSyncInactiveContentVisibility } from './useSyncInactiveContentVisibility'

/**
 * Returns functions for toggles and closing menu inside visibility settings popover.
 */
export const useClickMenuItem = () => {
    const { syncToLocalStorage } = useSyncInactiveContentVisibility()
    const { visibilitySettingValues } = useShallowEditorActionBar((state) => ({
        visibilitySettingValues: state.visibilitySettingValues,
    }))
    const {
        setVisibilitySettingValues,
        setIsVisibilitySettingsMenuDisplayed,
    } = useEditorActionBarActions()
    const onClickMenuItem = useCallback(
        (
            actionType: keyof typeof visibilitySettingValues,
            actionValue: boolean
        ) => {
            setVisibilitySettingValues?.({
                ...visibilitySettingValues,
                [actionType]: actionValue,
            })

            if (actionType === 'isInactiveContentVisible') {
                syncToLocalStorage(actionValue)
            }
        },
        [
            visibilitySettingValues,
            setVisibilitySettingValues,
            syncToLocalStorage,
        ]
    )
    const onCloseMainMenu = useCallback(() => {
        setIsVisibilitySettingsMenuDisplayed?.(false)
    }, [setIsVisibilitySettingsMenuDisplayed])
    return {
        onClickMenuItem,
        onCloseMainMenu,
    }
}
